export enum UserRole {
  Admin = 'Admin',
  Student = 'Student',
  Guide = 'Guide',
}
